<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white; text-align: center; margin-bottom: 10px">Autism Department</h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: fit; border-radius: 10px"
      src="assets/img/school/autism.jpg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body text-justify">
            <p>
              "Proyash-Chattogram", Educational Institute for special children
              has been providing Services to Children with various special needs
              since 2006. One of them is Autism Department. <br /><br />
              Proyash-Chattogram is working to change the Common Perception of
              Autism. Autism is not a disease, it is a neuro developmental
              disorder.<br /><br />
              Currently Autism Department of Proyash-Chattogram is serving 67
              students in four separate branches in morning shift and 30
              students in separate branches in Day shift. Autism Department has
              a total of 7 teachers, 3 teaching assistance and 11 nannies
              engaged in both shift for the Caring of Autism Children. The
              Autism Department assesses the age and performance of the students
              and taken their future plan. In the meantime for this students has
              taken short term and long- term goals and action plans are made
              accordingly and through various class based education and
              training, they are made suitable for living a normal life. Various
              class based activities are conducted so that children with Autism
              can gain independence in family and social life. Such as garments
              training, Apart from this, Autism Department is working to develop
              the talent of the students of Autism Department through their
              participation in various social, cultural events, sports and
              national level events.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
